import { FormEvent, useState } from 'react';
import {
  unsubscribeNewsletter,
  UnsubscribeNewsletterParams,
  unsubscribeNotification,
  UnsubscribeNotificationParams
} from '~/helpers/orchestration/subscribe';
import { ErrorResponse } from '~/helpers/sell-flow';

export type SubmitError =
  | null
  | { [s: string]: string | string[] | { [s: string]: string | string[] } }
  | string
  | undefined;

export interface Submit {
  isLoading: boolean;
  isCompleted: boolean;
  errors: null | SubmitError;
  handleSubmit: (event: FormEvent) => void;
}

interface Props {
  params: UnsubscribeNotificationParams | UnsubscribeNewsletterParams;
  children: (submit: Submit) => JSX.Element;
}

const NotificationUnsubscribeSubmit = ({ params, children }: Props) => {
  const [isLoading, setLoading] = useState(false);
  const [isCompleted, setCompleted] = useState(false);
  const [errors, setErrors] = useState<SubmitError>(null);

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();

    setLoading(true);

    if ('newsletterId' in params) {
      unsubscribeNewsletter(params)
        .then(() => {
          setLoading(false);
          setCompleted(true);
        })
        .catch((error: ErrorResponse) => {
          setErrors(error?.response?.data?.message);
          setLoading(false);
        });
    } else {
      unsubscribeNotification(params)
        .then(() => {
          setLoading(false);
          setCompleted(true);
        })
        .catch((error: ErrorResponse) => {
          setErrors(error?.response?.data?.message);
          setLoading(false);
        });
    }
  };

  return children({
    isLoading: isLoading,
    isCompleted: isCompleted,
    errors: errors,
    handleSubmit: handleSubmit
  });
};

export default NotificationUnsubscribeSubmit;
